module.exports = __webpack_public_path__ + "img/done-status-white.f4160f45.svg";